module.exports = __webpack_public_path__ + "img/LogoPotenz.edaf8a44.jpg";